/**
 * Serialization utilities for API data
 */
/**
 * Recursively convert Date objects to ISO strings
 */
export function serializeDates(obj) {
    if (obj === null || obj === undefined) {
        return obj;
    }
    if (obj instanceof Date) {
        return obj.toISOString();
    }
    if (Array.isArray(obj)) {
        return obj.map(item => serializeDates(item));
    }
    if (typeof obj === 'object') {
        const serialized = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                serialized[key] = serializeDates(obj[key]);
            }
        }
        return serialized;
    }
    return obj;
}
/**
 * Recursively convert ISO strings to Date objects
 */
export function deserializeDates(obj) {
    if (obj === null || obj === undefined) {
        return obj;
    }
    if (typeof obj === 'string' && isISODateString(obj)) {
        return new Date(obj);
    }
    if (Array.isArray(obj)) {
        return obj.map(item => deserializeDates(item));
    }
    if (typeof obj === 'object') {
        const deserialized = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                deserialized[key] = deserializeDates(obj[key]);
            }
        }
        return deserialized;
    }
    return obj;
}
/**
 * Check if string is ISO date format
 */
function isISODateString(str) {
    // ISO 8601 format: YYYY-MM-DDTHH:mm:ss.sssZ
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/;
    return isoDateRegex.test(str);
}
//# sourceMappingURL=serialization.js.map